import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormLabel,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	TextField,
} from "@mui/material";
import Select from "@mui/material/Select";
import { useEffect, useState } from "react";
import type { StoreItem } from "src/pages/StoreItemsPage";
import { createBlobInContainer, STORAGE_URL } from "src/utils/azureBlob";
import { post, put } from "src/utils/networkUtils";
import Iconify from "../iconify";

type NewStoreItem = Exclude<StoreItem, "marketplaceStoreItemId">;

const defaultItem: NewStoreItem = {
	name: "",
	description: "",
	image: "",
	productId: "coins_100",
	amount: 0,
	store: 0,
	listImage: "",
	price: 0,
	priceLabel: "",
	itemType: 0,
};

export default function StoreItemDialog(props) {
	const [item, setItem] = useState<NewStoreItem | StoreItem | null>(null);
	const [loading] = useState(false);

	useEffect(() => {
		if (props?.item) {
			setItem(props.item);
		} else {
			setItem(defaultItem);
		}
	}, [props.item]);

	const handleChange = (e) => {
		const { id, value } = e.target;
		setItem((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const onSuccess = () => {
		if (!item) {
			return;
		}
		item.tenantId = 1;
		if (props?.item) {
			put(`/admin/marketplace/store-items/${item.marketplaceStoreItemId}`, item).then((response) => {
				props.onSuccessHandler();
			});
		} else {
			post(`/admin/marketplace/store-items`, item).then((response) => {
				props.onSuccessHandler();
			});
		}
	};
	const onCancel = () => {
		props.onClose();
	};

	const uploadFiles = (event, name) => {
		if (event.target.files.length > 0) {
			const files = event.target.files;

			const uploadPromises = [];
			uploadPromises.push(createBlobInContainer(files[0]));

			if (uploadPromises.length > 0) {
				const uploadFiles = async () => {
					await Promise.all(uploadPromises);
					setItem((prevState) => ({
						...prevState,
						[name]: `${STORAGE_URL}/${files[0].name}`,
					}));
				};

				uploadFiles().catch(console.error);
			}
		}
	};
	console.log(item);
	return (
		<Dialog open={props.open} onClose={() => {}} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">Store Item</DialogTitle>
			<DialogContent>
				{item === null || loading ? (
					<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
						<CircularProgress />
					</Box>
				) : (
					<Grid container>
						<Grid item xs={12} sx={{ m: 0, p: 1 }}>
							<TextField id="productId" label="Product ID" fullWidth value={item.productId} variant="standard" onChange={handleChange} />
						</Grid>
						<Grid item xs={4} sx={{ m: 0, p: 1 }}>
							<TextField id="name" label="Name" fullWidth value={item.name} variant="standard" onChange={handleChange} />
						</Grid>
						<Grid item xs={4} sx={{ m: 0, p: 1 }}>
							<FormControl sx={{ m: 1, minWidth: 150 }} size="small">
								<InputLabel id="demo-simple-select-label">Type</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={item.itemType}
									label="Store"
									onChange={(event) =>
										setItem((prevState) => ({
											...prevState,
											itemType: event.target.value,
										}))
									}
								>
									<MenuItem value="0" key={`store-0`}>
										Coins
									</MenuItem>
									<MenuItem value="2" key={`store-2`}>
										AllAccessPass
									</MenuItem>
									<MenuItem value="4" key={`store-4`}>
										Ticket
									</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sx={{ m: 0, p: 1 }}>
							<TextField
								id="description"
								label="Description"
								fullWidth
								value={item.description}
								variant="standard"
								onChange={handleChange}
							/>
						</Grid>
						<Grid item xs={3} sx={{ m: 0, p: 1 }}>
							<FormControl sx={{ m: 1, minWidth: 120 }} size="small">
								<InputLabel id="demo-simple-select-label">Store</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={item.store}
									label="Store"
									onChange={(event) =>
										setItem((prevState) => ({
											...prevState,
											store: event.target.value,
										}))
									}
								>
									<MenuItem value="0" key={`store-0`}>
										Apple
									</MenuItem>
									<MenuItem value="1" key={`store-1`}>
										Google
									</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={3} sx={{ m: 0, p: 1 }}>
							<TextField id="amount" label="Coins Amount" fullWidth value={item.amount} variant="standard" onChange={handleChange} />
						</Grid>
						<Grid item xs={3} sx={{ m: 0, p: 1 }}>
							<TextField
								id="priceLabel"
								label="Price Label (Android)"
								fullWidth
								value={item.priceLabel}
								variant="standard"
								onChange={handleChange}
							/>
						</Grid>
						<Grid item xs={3} sx={{ m: 0, p: 1 }}>
							<TextField id="price" label="Price Value" fullWidth value={item.price} variant="standard" onChange={handleChange} />
						</Grid>

						<Grid item xs={6}>
							<FormLabel id="card-format-label">Image</FormLabel>
							<IconButton color="primary" aria-label="upload picture" component="label">
								<input hidden accept="image/*" type="file" onChange={(event) => uploadFiles(event, "image")} />
								<Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
							</IconButton>
							{item.image ? (
								<img
									style={{
										margin: "0 auto",
										width: 100,
										background: "grey",
									}}
									alt="Store Item"
									src={item.image}
								/>
							) : null}
						</Grid>
						<Grid item xs={6}>
							<FormLabel id="card-format-label">List Image</FormLabel>
							<IconButton color="primary" aria-label="upload picture" component="label">
								<input hidden accept="image/*" type="file" onChange={(event) => uploadFiles(event, "listImage")} />
								<Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
							</IconButton>
							{item.listImage ? (
								<img
									style={{
										margin: "0 auto",
										width: 100,
										background: "grey",
									}}
									alt="Store item"
									src={item.listImage}
								/>
							) : null}
						</Grid>
					</Grid>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => onCancel()}>Cancel</Button>
				<Button onClick={() => onSuccess()} autoFocus disabled={item === null || !item.name || !item.description || !item.image}>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
}
